var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ImageParser mx-auto"},[_c('img',{staticClass:"img-fluid animate__animated animate__fadeIn",attrs:{"src":_vm.content}})])
}
var staticRenderFns = []

export { render, staticRenderFns }